import styled from 'styled-components';
import { Card as DefCard, Colors } from '@blueprintjs/core';

export const Card = styled(DefCard)`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background: ${Colors.DARK_GRAY2} !important;
`;
